import React, { useState } from 'react';
import { CheckCircle, Copy, X, Zap } from 'lucide-react';
import * as api from '../../services/api';

function OnboardingWizard({ status, onComplete, onApplyStarter }) {
  const [step, setStep] = useState(1);
  const [selectedPack, setSelectedPack] = useState('');
  const [applying, setApplying] = useState(false);
  const [connInfo, setConnInfo] = useState(null);
  const host = 'panel.streaminfinitytv.com';

  const copyText = (text) => {
    navigator.clipboard.writeText(text);
  };

  const loadConn = async () => {
    try {
      const res = await api.customerGetConnectionInfo();
      setConnInfo(res.data);
    } catch (e) { /* ignore */ }
  };

  const goStep = async (n) => {
    if (n === 4 && !connInfo) await loadConn();
    setStep(n);
  };

  const finish = async (opts = {}) => {
    await api.customerCompleteOnboarding(opts);
    onComplete();
  };

  const applyPack = async () => {
    if (!selectedPack) return;
    setApplying(true);
    try {
      const res = await onApplyStarter(selectedPack);
      alert(`Enabled ${res.data.enabled} items in the ${res.data.pack} pack`);
      setStep(4);
    } catch (e) {
      alert('Failed: ' + (e.response?.data?.error || e.message));
    } finally {
      setApplying(false);
    }
  };

  if (!status?.show_wizard) return null;

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
      <div className="table-container" style={{ maxWidth: '560px', width: '100%', margin: 0 }}>
        <div className="table-header" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <h3>Welcome to Multi-Provider Setup</h3>
          <button className="btn btn-secondary" style={{ padding: '4px 8px' }} onClick={() => finish({ dismissed: true })}><X size={16} /></button>
        </div>
        <div style={{ padding: '24px' }}>
          {step === 1 && (
            <>
              <p style={{ color: '#6b7280', marginBottom: '16px' }}>
                You have <strong>{status.provider_lines} provider lines</strong> connected. We'll merge them into one unified experience with automatic backup if a stream fails.
              </p>
              <div className="stats-grid" style={{ gridTemplateColumns: 'repeat(3, 1fr)', marginBottom: '20px' }}>
                <div className="stat-card"><div className="stat-value">{status.content_stats?.channels?.toLocaleString()}</div><div className="stat-label">Channels</div></div>
                <div className="stat-card"><div className="stat-value">{status.content_stats?.movies?.toLocaleString()}</div><div className="stat-label">Movies</div></div>
                <div className="stat-card"><div className="stat-value">{status.content_stats?.series?.toLocaleString()}</div><div className="stat-label">Series</div></div>
              </div>
              <button className="btn btn-primary" onClick={() => goStep(2)}>Continue</button>
            </>
          )}

          {step === 2 && (
            <>
              <p style={{ color: '#6b7280', marginBottom: '16px' }}>Pick a starter pack to enable content quickly. You can change this anytime from Channels/Movies/Series.</p>
              <div style={{ display: 'grid', gap: '10px', marginBottom: '20px' }}>
                {(status.starter_packs || []).map(p => (
                  <label key={p.id} style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '12px', border: selectedPack === p.id ? '2px solid #3b82f6' : '1px solid #e5e7eb', borderRadius: '8px', cursor: 'pointer' }}>
                    <input type="radio" name="pack" checked={selectedPack === p.id} onChange={() => setSelectedPack(p.id)} />
                    <strong>{p.label}</strong>
                  </label>
                ))}
              </div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <button className="btn btn-secondary" onClick={() => goStep(1)}>Back</button>
                <button className="btn btn-primary" disabled={!selectedPack || applying} onClick={applyPack}>{applying ? 'Applying...' : 'Apply Starter Pack'}</button>
                <button className="btn btn-secondary" onClick={() => goStep(4)}>Skip</button>
              </div>
            </>
          )}

          {step === 4 && (
            <>
              <p style={{ color: '#6b7280', marginBottom: '16px' }}>Use these credentials in TiviMate, Chillio, IPTV Smarters, or any Xtream app:</p>
              <table style={{ width: '100%', marginBottom: '16px' }}>
                <tbody>
                  <tr><td style={{ fontWeight: 600, padding: '8px 0' }}>Server</td><td><code>https://{host}</code> <button className="btn btn-secondary" style={{ padding: '2px 6px', marginLeft: 8 }} onClick={() => copyText(`https://${host}`)}><Copy size={12} /></button></td></tr>
                  {connInfo && (
                    <tr><td style={{ fontWeight: 600 }}>Username</td><td><code>{connInfo.username}</code></td></tr>
                  )}
                </tbody>
              </table>
              <button className="btn btn-primary" onClick={() => finish({})}><CheckCircle size={16} style={{ marginRight: 6 }} />Done — Go to Dashboard</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default OnboardingWizard;
